/** 挂在在window上面的对象 */
export enum PluginKey {
  EXIF = 'EXIF',
  WECHAT = 'wx',
  JSEncrypt = 'JSEncrypt',
  Decimal = 'Decimal',
  Ths = 'Ths',
  Fetch = 'fetch',
  Grecaptcha = 'grecaptcha',
}

export enum LogModule {
  WeChat = 'WeChat',
  Encrypt = 'Encrypt',
  Validate = 'Validate',
  Lang = 'Lang',
  JSBridge = 'JSBridge',
  Image = 'Image',
  File = 'File',
  Detector = 'Detector',
  Cookies = 'Cookies',
  Url = 'Url',
  Ths = 'Ths',
  Utils = 'Utils',
  Http = 'Http',
  Launch = 'Launch',
  Config = 'Config',
  Compress = 'Compress',
}
